<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm cancellation</v-card-title>
    <v-card-text>Are you sure you want to cancel {{ hpbz.hpbz_nr }} {{ hpbz.plan_code }} Arrival {{hpbz.hpbz_van_datum}}  Departure {{hpbz.hpbz_tm_datum}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="cancelHpbz">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hpbz: {}
    }
  },
  methods: {
    open(hpbz_encrid,huis_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/hpbz/getHpbzToCancel.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHpbzToCancel"
          },
          getHpbzToCancel: {
            hpbz_encrid: hpbz_encrid,
            huis_encrid: huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hpbz = res.data.getHpbzToCancel;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelHpbz() { 
      this.$axios
        .post("ares/json/ares/hpbz/cancelHpbz.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "cancelHpbz"
          },
          cancelHpbz: {
            hpbz_encrid: this.hpbz.hpbz_encrid,
            huis_encrid: this.hpbz.huis_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            window.opener.location.reload();
            this.$router.reload('/hpbz/onHpbz/' + res.data.cancelHpbz.hpbz_encrid + '/' + res.data.cancelHpbz.huis_encrid);  
             
             /* window.close(); */
             
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.cancelHpbz.text,
              color: res.data.cancelHpbz.color
            });           
            this.dialog = false; 
          }
        })
    },
  }
}
</script>

